import { camelToSnake, excludeObjNullValue, nullIfIsEmpty, snakeToCamel, toSnakeCase } from '../common';
import { isEmpty } from '../validation';
import { BASE_URL, BASE_API_KEY, BASE_APP_SECRET } from '../../config';
import axios from 'axios';
import qs from "qs";

const axios_api = axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
    headers: {
        'api-key': BASE_API_KEY,
        'api-hash': BASE_API_KEY,
        'Content-Type': 'application/json',
    }
});

const postJSON = (url, payload, config = {}) => {
    payload.deviceId = "49.205.111.56";
    payload.userType = "nola-admin";
    payload.developerKey = "yes";

    return axios_api.post(url, payload, config)
        .then(({ data }) => snakeToCamel(data.result))
        .catch((error) => {
            if (axios.isCancel(error)) {
                return null;
            }
            return Promise.reject(snakeToCamel(error.response));
        });
};

const postloginJSON = (url, payload, config = {}) => {
    // console.log(url);
    payload.deviceId = "49.205.111.56";
    payload.userType = "nola-admin";
    payload.developerKey = "yes";

    return axios_api.post(url, payload, config)
        .then(({ data }) => snakeToCamel(data.result))
        .catch((error) => {
            if (axios.isCancel(error)) {
                return null;
            }
            return Promise.reject(snakeToCamel(error.response));
        });
};

const putJSON = (url, payload, config = {}) => {
    return axios_api.put(url, payload, config)
        .then(({ data }) => snakeToCamel(data.result))
        .catch((error) => {
            if (axios.isCancel(error)) {
                return Promise.reject(null);
            }
            return Promise.reject(snakeToCamel(error.response));
        });
};

const getJSON = (url, config = {}) => {
    return axios_api.get(url, config)
        .then(({ data }) => snakeToCamel(data.result))
        .catch((error) => {
            if (axios.isCancel(error)) {
                return Promise.reject(null);
            }
            return Promise.reject(snakeToCamel(error.response));
        });
};

const deleteXHR = (url, config = {}) => {
    return axios_api.delete(url, config)
        .then(({ data }) => snakeToCamel(data.result))
        .catch((error) => {
            if (axios.isCancel(error)) {
                return Promise.reject(null);
            }
            return Promise.reject(snakeToCamel(error.response));
        });
};

const postFormData = (url, formData) => {
    return axios_api.post(
        url,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
        .then(({ data }) => Promise.resolve(snakeToCamel(data)))
        .catch((error) => {
            if (axios.isCancel(error)) {
                return Promise.reject(null);
            }
            return Promise.reject(snakeToCamel(error.response));
        });
};

const request = {
    axios_api,
    postJSON,
    getJSON,
    deleteXHR,
    putJSON,
    postFormData,
    postloginJSON
};

const fetchList = (url, q, page = 1, perPage = 10, sortOpts = {}, extraParams = {}, config = {}) => request.getJSON(
    url,
    {
        params: {
            q,
            page,
            per_page: perPage,
            sort: typeof sortOpts.sortField === 'string' ? toSnakeCase(sortOpts.sortField) : undefined,
            dir: sortOpts.sortDir,
            ...camelToSnake(extraParams),
        },
        ...config,
    }
);

const fetchDetail = (url, params, config = {}) => request.postJSON(
    url, params, config
);

const translationMap = {
    "Sesión": "Session",
    "Sesion": "Session",
    "Sección": "Section",
    "Seccion": "Section",
    "Prueba posterior": "Post Test",
    "Guía del módulo": "Module Guide",
    "Introducción": "Intro"
};

const translateToEnglish = (text) => {
    if (!text) return "";
    let translated = text;

    // Sort keys by length so "Guía del módulo" is checked before "módulo"
    const keys = Object.keys(translationMap).sort((a, b) => b.length - a.length);

    keys.forEach(key => {
        // Use word boundaries or exact matching if possible
        const regex = new RegExp(key, "gi");
        translated = translated.replace(regex, translationMap[key]);
    });
    return translated;
};

const fetchMyAssignment = (assignmentId, contentparams) => {

    const rawTitle = localStorage.getItem('AssessmentName');
    const englishTitle = translateToEnglish(rawTitle);
    //testTitle:  localStorage.getItem('AssessmentName')
    return request.postJSON('/module/player/assignments', excludeObjNullValue({
        oper: 'assignments',
        sessionid: contentparams[1],
        moduleid: contentparams[2],
        scheduleid: contentparams[3],
        scheduletype: contentparams[4],
        testerid: contentparams[5],
        testerid1: contentparams[6],
        pageid: contentparams[7],
        recordid: contentparams[9],
        recordid1: contentparams[10],
        testTitle:  englishTitle
    })
    );
};

const setModuleProgress = (payload, contentparams) => {
    return request.postJSON(
        // `/modules/${payload.moduleId}/updateprogress`,
        '/module/player/update/progress',
        excludeObjNullValue(
            {
                oper: 'updateprogress',
                session_number: payload.sessionNum,
                // page_number: parseInt(payload.pageNum),
                pageid: parseInt(payload.pageNum),
                completed: payload.completed,
                student_input: payload.answers,
                sessionid: payload.sessionNum,
                moduleid: contentparams[2],
                scheduleid: contentparams[3],
                scheduletype: contentparams[4],
                testerid: contentparams[5],
                testerid1: contentparams[6],
                recordid: contentparams[9],
                recordid1: contentparams[10]

            }
        )
    );
};

const gradeModuleGradeItemQuest = (payload, contentparams) => request.postJSON(
    '/module/player/grades/quest',
    {
        oper: 'gradesquest',
        gradetype: payload.gradeType,
        sessionid: contentparams[1],
        moduleid: contentparams[2],
        scheduleid: contentparams[3],
        scheduletype: contentparams[4],
        testerid: contentparams[5],
        testerid1: contentparams[6],
        moduletype: payload.moduletype,
        pageid: contentparams[7],
        selectedans: payload.selectedidarray,// joyson
        recordid: contentparams[9],
        recordid1: contentparams[10],
        grades: payload.grades.map(grade => ({
            user_id: grade.userId,
            points_earned: grade.points,
            student_answers: grade.answers
        })),
    }
);


const gradeModuleGradeItem = (payload, contentparams) => request.postJSON(
    '/module/player/grades',
    {
        oper: 'grades',
        gradetype: payload.gradeType,
        sessionid: contentparams[1],
        moduleid: contentparams[2],
        scheduleid: contentparams[3],
        scheduletype: contentparams[4],
        testerid: contentparams[5],
        testerid1: contentparams[6],
        moduletype: payload.moduletype,
        pageid: contentparams[7],
        recordid: contentparams[9],
        recordid1: contentparams[10],
        selectedans: (payload.selectedidarray.length > 0) ? payload.selectedidarray : [],// joyson
        grades: payload.grades.map(grade => ({
            user_id: grade.userId,
            points_earned: grade.points,
            student_answers: grade.answers
        })),
    }
);


const gradeModuleGradeItemAssessment = (payload, contentparams) => request.postJSON(
    '/module/player/assessments',
    {
        oper: 'assessment',
        sessionid: contentparams[1],
        moduleid: contentparams[2],
        scheduleid: contentparams[3],
        scheduletype: contentparams[4],
        testerid: contentparams[5],
        testerid1: contentparams[6],
        pageid: contentparams[7],
        recordid: contentparams[9],
        recordid1: contentparams[10]
    }
);

const createExtendedContentPackage = (payload, contentparams) => {
    return request.postJSON(` `, excludeObjNullValue({
        name: payload.name,
        content_id: payload.contentId
    }));
};


const updateExtendedContentPackage = (payload, contentparams) => {
    return request.postJSON('/module/player/update/extent-content', excludeObjNullValue({
        oper: 'updateextendcontent',
        extend_text: payload.contentJson,
        extendedcontentid: payload.extendedContentId,
        extendedtextid: payload.extendedtextId,
        pageid: payload.pageid,
        sessionid: contentparams[1],
        moduleid: contentparams[2],
        testerid: contentparams[5],
    }
    )
    );
};


const fetchExtendedContent = (extendedContentId, params = {}, contentparams) => fetchDetail(
    '/module/player/fetch/extent-content',
    excludeObjNullValue({
        oper: 'fetchextendcontent',
        sessionid: (contentparams) ? contentparams[1] : '',
        moduleid: (contentparams) ? contentparams[2] : '',
        scheduleid: (contentparams) ? contentparams[3] : '',
        scheduletype: (contentparams) ? contentparams[4] : '',
        testerid: (contentparams) ? contentparams[5] : '',
        testerid1: contentparams[6],
        pageId: params.pageNum,
        role: params.role,
        extendid: extendedContentId
    })
);


function fetchContent(contentId, params = {}, contentparams) {
    const url = '/module/player/fetch/content';
    // console.log("fetchContent", contentparams);

    if (!Array.isArray(contentparams) || contentparams.length < 6) {
        console.error("Invalid contentparams:", contentparams);
        return;
    }

    const testerId = contentparams[5] || '';  // Ensure testerId is retrieved safely

    // console.log("Extracted testerId:", testerId);

    // Function to update the iframe dynamically
    function updateIframeSrc() {
        // console.log("Attempting to update iframe with testerId:", testerId);
        let checkIframe = setInterval(() => {
            let iframe = document.getElementById("dynamicIframe");
            if (iframe) {
                clearInterval(checkIframe);
                iframe.src = `https://stageapp-next.staracademyapp.com/pages/resume/${testerId}`;
                // console.log("Iframe src updated to:", iframe.src);

                const bookContent = document.querySelector(".book-content");
                if (bookContent) {
                    bookContent.classList.add("expanded");
                }
            }
        }, 100);
    }

    // Call updateIframeSrc immediately instead of relying on DOMContentLoaded
    updateIframeSrc();

    const payload = {
        oper: 'fetchcontent',
        classroom_id: params.classroomId,
        assignment_id: params.assignmentId,
        module_id: contentId,
        recordid: contentparams[9],
        recordid1: contentparams[10],
        sessionid: contentparams[1] || '',
        moduleid: contentparams[2] || '',
        scheduleid: contentparams[3] || '',
        scheduletype: contentparams[4] || '',
        testerid: testerId,
        testerid1: contentparams[6] || '',
        pageId: params.pageNum,
        role: params.role
    };

    return request.postJSON(url, payload);
}



function getCurrentUsers(contentparams) {
    const url = '/module/player/check-user';
    // console.log("getCurrentUsers");
    // console.log(contentparams);
    const payload = {
        oper: 'loggedin',
        testerid: contentparams[5],
        testerid1: contentparams[6],
    };
    return request.postJSON(url, payload);
}


function postLoginData(studentId, studentId1) {
    // console.log("postLoginData");
    // console.log(studentId);
    const url = '/module/player/login-user';
    const payload = {
        oper: 'login',
        testerid: studentId,
        testerid1: studentId1
    };
    // var queryString = Object.keys(payload).map(key => key + '=' + payload[key]).join('&');
    return request.postJSON(url, payload);
}

function postLogoutData(id) {
    //const url = '/logout/' + id;
    const url = '/module/player/logout';
    const payload = {
        testerid: id
    };
    return request.postJSON(url, payload);
}


// submit button close
const playercloseandsubmitcalling = (contentparams) => request.postJSON(
    'https://stageclasses.staracademyapp.com/v1/module/player/close',
    {
        oper: 'gradesquest',
        sessionid: contentparams[1],
        moduleid: contentparams[2],
        scheduleid: contentparams[3],
        scheduletype: contentparams[4],
        testerid: contentparams[5],
        testerid1: contentparams[6],
        pageid: contentparams[7],
    }
);
// End for submit button close api calling

export {
    fetchContent,
    fetchExtendedContent,
    updateExtendedContentPackage,
    setModuleProgress,
    postLoginData,
    postLogoutData,
    getCurrentUsers,
    //setAuthorizationToken,
    gradeModuleGradeItem,
    gradeModuleGradeItemAssessment,
    gradeModuleGradeItemQuest,
    fetchMyAssignment,
    playercloseandsubmitcalling
};



// WEBPACK FOOTER //
// ./src/js/utilities/api/index.js